import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ overline, title, sub, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && (
      <p className="font-mono2 text-xs tracking-[0.25em] uppercase mb-4 text-[#0055FF]">
        {overline}
      </p>
    )}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter leading-[1.08] text-slate-900">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-600">{sub}</p>}
  </div>
);
